/**
 * Setting that the low order minimum threshold for each currency supported by Faire. * https:www.notion.so/Highlight-Low-minimums-c3d3f1b148f94fe6b2589ed9fa902247
 */
export const LOW_ORDER_MINIMUM_THRESHOLD = 'LOW_ORDER_MINIMUM_THRESHOLD';
